module.exports = __webpack_public_path__ + "static/img/starry_night.abdb93a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/starry_night.jpg
// module id = /3my
// module chunks = 1